import { useState } from 'react';

interface ShareModalProps {
  title: string;
  onClose: () => void;
}

export default function ShareModal({ title, onClose }: ShareModalProps) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-foreground-950/50" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6 animate-fade-up">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">分享「{title}」</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-background-200"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <p className="mt-3 text-sm text-foreground-500">复制下方链接，把它分享给同样喜欢影视的朋友。</p>
        <div className="mt-4 flex items-center gap-2">
          <input
            readOnly
            value={url}
            onFocus={(e) => e.target.select()}
            className="h-11 w-full rounded-md border border-background-200 bg-background-100 px-3 text-sm text-foreground-700 outline-none"
          />
          <button
            type="button"
            onClick={handleCopy}
            className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'} />
            {copied ? '已复制' : '复制'}
          </button>
        </div>
      </div>
    </div>
  );
}